import { StyledValuesBarItem, StyledValuesBar } from './ValuesBar.style';
import { getDataWithPercentageValues } from './ValuesBar.utils';
import Tooltip from '@material-ui/core/Tooltip';
import ValueBarTooltip from './ValuesBarTooltip';
import { boolPropsToClassNames } from 'common/utils/style.utils';

const ValuesBar = ({
  data = [],
  withPercents = false,
  withTooltip = false,
  roundedView = false
}) => {
  const parsedData = withPercents ? getDataWithPercentageValues(data) : data;

  return (
    <Tooltip
      title={<ValueBarTooltip data={parsedData} withPercents={withPercents} />}
      disableHoverListener={!withTooltip}
    >
      <StyledValuesBar className={boolPropsToClassNames({ roundedView })}>
        {parsedData.map(item => {
          const { name, value, percentage, color } = item;
          if (value === 0) return null;
          return (
            <StyledValuesBarItem
              key={name}
              value={withPercents ? percentage : value}
              color={color}
            />
          );
        })}
      </StyledValuesBar>
    </Tooltip>
  );
};

export default ValuesBar;
